import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Typography } from '@material-ui/core';

import Loader from 'components/Loader';
import { isSaleFullyReturned } from 'utils';
import { Sales } from 'containers/Forms/RecentSalesList';

import Panel from './Panel';

type Props = {
  sales: Sales;
  title: string;
  showName: boolean;
  loadMore?: () => void;
  loadingText: string;
  getRowExpandedState(key: string): boolean;
  setRowExpandedState(key: string, value: boolean): void;
};

const PurchasesList: React.FC<Props> = ({
  loadingText,
  title,
  showName,
  sales,
  loadMore,
  getRowExpandedState,
  setRowExpandedState,
}) => {
  const { t } = useTranslation('customer');
  return (
    <Loader
      withPadding
      show={Boolean(loadingText)}
      loadingText={loadingText}
      block
      data-testid="previous-purchases"
    >
      <Typography data-testid="title">{title}</Typography>
      {sales.docs.map(s => (
        <Panel
          key={s.id}
          sale={s}
          isSaleFullyReturned={isSaleFullyReturned(s, sales.returnedRows)}
          showName={showName}
          isExpanded={getRowExpandedState(String(s.id))}
          setExpanded={setRowExpandedState}
        />
      ))}
      {sales.docs.length !== 0 && loadMore && (
        <Button variant="contained" color="secondary" onClick={loadMore}>
          {t('customerView.purchases.loadMore')}
        </Button>
      )}
    </Loader>
  );
};

export default PurchasesList;
